import { applyMiddleware, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { api, normalize } from "./middlewares";
import rootReducer from "state/reducers";
import { denormalize } from "normalizr";

export function configureStore(initialState = {}) {
  const composedEnhancers = composeWithDevTools(
    applyMiddleware(thunkMiddleware, api, normalize),
  );
  const store = createStore(rootReducer(), initialState, composedEnhancers);
  if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept("state/reducers", () =>
      store.replaceReducer(rootReducer()),
    );
  }
  return store;
}

const store = configureStore();

export function getStoreEntity(item, Schema) {
  return denormalize(item, Schema, store.getState().entities);
}

export default store;
